module.exports = __webpack_public_path__ + "static/media/paso1.f6357a82.png";